import { Routes } from '@angular/router';

import {
  TemplateComponent,
  SenderDomainComponent,
  EmailComponent,
} from './containers/';

export const EMAIL_ROUTES: Routes = [
  {
    path: '',
    component: EmailComponent,
    children: [
      {
        path: 'template',
        component: TemplateComponent,
      },
      {
        path: 'sender-domain',
        component: SenderDomainComponent,
      },
    ],
  },
];
